import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function Customers() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    CustomerData: [],
    searchQuery: "",
  });

  useEffect(() => {
    GetCustomerList(pageStates?.currentPage);
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.pageSize,
    filterDetails?.orderBy,
  ]);

  const GetCustomerList = (pageNumber) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_customer + "?" + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.customer?.map((item) => ({
          ...item,
          toggleStatus: item?.status,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          CustomerData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggle();
  };
  const HandleView = (data) => {
    navigate(RoutesLink.customer_detail + `/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_customer, { state: { data: data } });
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_customer + `?customerId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetCustomerList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const handleStatusToggle = (data, status) => {
    let submitData = {};
    submitData = {
      status: status ? 0 : 1,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.Update_Customer + `?customerId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetCustomerList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Firm" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Contact Number" },
    { value: "address", label: "Address" },
    { value: "gstNumber", label: "GSTIN" },
    { value: "toggleStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    // {
    //   label: "Delete",
    //   className: "btn btn-link",
    //   icon: <DeleteIcon />,
    //   title: "delete",
    //   clickHandler: ActionHandler,
    // },
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Customer"}
          buttonText={"Add Customer"}
          buttonIcon={<PlusIcon />}
          buttonLink={RoutesLink?.add_customer}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              tableDataForExport={pageStates?.CustomerData}
              exportFileName={"Customers_Data"}
              exportColumns={[
                "name",
                "email",
                "phone",
                "address",
                "gstNumber",
              ]}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.CustomerData}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleStatusToggle={handleStatusToggle}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates?.pageSize}
            />
          </div>
        </div>
      </div>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
